import { RootState } from "../../../store";
import { AccountsViewType } from "../../accountsSlice";

export const accountsViewSelector = (state: RootState): AccountsViewType =>
  state.accounts.accountsView;
